import React from "react"
import ContentLoader from "react-content-loader"

const PostSkeleton = (props) => {

    return (

    <ContentLoader
        speed={1}
        width={760}
        height={520}
        viewBox="0 0 760 520"
        backgroundColor="#F0F0F0"
        foregroundColor="#e8e8e8"
        {...props}
    >
        <rect x="48" y="8" rx="3" ry="3" width="88" height="6" />
        <rect x="48" y="26" rx="3" ry="3" width="52" height="6" />
        <rect x="0" y="62" rx="3" ry="3" width="410" height="6" />
        <rect x="0" y="84" rx="3" ry="3" width="380" height="6" />
        <rect x="0" y="106" rx="3" ry="3" width="350" height="6" />
        <circle cx="20" cy="20" r="20" />
        <rect x="0" y="130" rx="0" ry="0" width="760" height="400" />
        <circle cx="730" cy="18" r="18" />
    </ContentLoader>

    )
}

export default PostSkeleton